"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var colors_1 = require("../colors");
var directionPath = {
    left: 'M19.7801 22L26.89 29.11L24 32L14 22L24 12L26.89 14.89L19.7801 22Z',
    top: 'M22 19.7801L14.89 26.89L12 24L22 14L32 24L29.11 26.89L22 19.7801Z',
    right: 'M24.2199 22L17.11 29.11L20 32L30 22L20 12L17.11 14.89L24.2199 22Z',
    bottom: 'M22 25.2199L14.89 18.11L12 21L22 31L32 21L29.11 18.11L22 25.2199Z',
};
var Chevron = function (_a) {
    var width = _a.width, height = _a.height, fill = _a.fill, direction = _a.direction;
    return (React.createElement("svg", { width: width, height: height, viewBox: "0 0 44 44", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: directionPath[direction], fill: fill })));
};
Chevron.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    fill: PropTypes.string,
    direction: PropTypes.string,
};
Chevron.defaultProps = {
    width: 40,
    height: 40,
    fill: colors_1.grey5,
    direction: 'right',
};
exports.default = Chevron;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2hldnJvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pY29ucy9DaGV2cm9uLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLDZCQUErQjtBQUMvQixzQ0FBd0M7QUFFeEMsb0NBQWdDO0FBRWhDLElBQU0sYUFBYSxHQUFHO0lBQ3BCLElBQUksRUFBRSxtRUFBbUU7SUFDekUsR0FBRyxFQUFFLG1FQUFtRTtJQUN4RSxLQUFLLEVBQUUsbUVBQW1FO0lBQzFFLE1BQU0sRUFBRSxtRUFBbUU7Q0FDNUUsQ0FBQztBQVFGLElBQU0sT0FBTyxHQUEyQixVQUFDLEVBQWdDO1FBQS9CLGdCQUFLLEVBQUUsa0JBQU0sRUFBRSxjQUFJLEVBQUUsd0JBQVM7SUFDdEUsT0FBTyxDQUNMLDZCQUFLLEtBQUssRUFBRSxLQUFLLEVBQUUsTUFBTSxFQUFFLE1BQU0sRUFBRSxPQUFPLEVBQUMsV0FBVyxFQUFDLElBQUksRUFBQyxNQUFNO1FBQ2hFLDhCQUFNLFFBQVEsRUFBQyxTQUFTLEVBQUMsUUFBUSxFQUFDLFNBQVMsRUFBQyxDQUFDLEVBQUUsYUFBYSxDQUFDLFNBQVMsQ0FBQyxFQUFFLElBQUksRUFBRSxJQUFJLEdBQUksQ0FDbkYsQ0FDUCxDQUFDO0FBQ0osQ0FBQyxDQUFDO0FBRUYsT0FBTyxDQUFDLFNBQVMsR0FBRztJQUNsQixLQUFLLEVBQUUsU0FBUyxDQUFDLFNBQVMsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxNQUFNLEVBQUUsU0FBUyxDQUFDLE1BQU0sQ0FBQyxDQUFRO0lBQ3ZFLE1BQU0sRUFBRSxTQUFTLENBQUMsU0FBUyxDQUFDLENBQUMsU0FBUyxDQUFDLE1BQU0sRUFBRSxTQUFTLENBQUMsTUFBTSxDQUFDLENBQVE7SUFDeEUsSUFBSSxFQUFFLFNBQVMsQ0FBQyxNQUFNO0lBQ3RCLFNBQVMsRUFBRSxTQUFTLENBQUMsTUFBYTtDQUNuQyxDQUFDO0FBRUYsT0FBTyxDQUFDLFlBQVksR0FBRztJQUNyQixLQUFLLEVBQUUsRUFBRTtJQUNULE1BQU0sRUFBRSxFQUFFO0lBQ1YsSUFBSSxFQUFFLGNBQUs7SUFDWCxTQUFTLEVBQUUsT0FBTztDQUNuQixDQUFDO0FBRUYsa0JBQWUsT0FBTyxDQUFDIn0=


//////////////////
// WEBPACK FOOTER
// ./node_modules/@riiid/santa-closet-web/icons/Chevron.js
// module id = 59
// module chunks = 0